import React, { Component } from "react";

export default class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: "",
      aciklama: "",
      fullName: "",
      iletisimNedeni: "",
    };
  }

  handlePhoneChange = (e) => {
    const input = e.target.value;

    // Remove all non-digit characters
    const digitsOnly = input.replace(/\D/g, "");

    // Limit to 10 digits (Turkish mobile numbers without country code)
    const truncated = digitsOnly.substring(0, 10);

    // Format the phone number as user types (XXX XXX XX XX)
    let formatted = "";
    if (truncated.length > 0) {
      formatted = truncated.replace(
        /(\d{3})(\d{0,3})(\d{0,2})(\d{0,2})/,
        (_, p1, p2, p3, p4) => {
          let result = p1;
          if (p2) result += " " + p2;
          if (p3) result += " " + p3;
          if (p4) result += " " + p4;
          return result;
        }
      );
    }

    this.setState({ phone: formatted });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const phoneDigits = this.state.phone.replace(/\D/g, "");
    if (phoneDigits.length !== 10) {
      alert("Lütfen geçerli bir telefon numarası giriniz (5XX XXX XX XX)");
      return;
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/messages/set-message`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        fullName: this.state.fullName,
        phone: this.state.phone,
        type: this.state.iletisimNedeni,
        message: this.state.aciklama,
        messageTo: null,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            alert("Çok fazla istek atıldı 15 dakika bekleyin.");
            return Promise.resolve();
          });
        }
        return response.json();
      })
      .then((result) => {
        if (result["m"] == "basarili") {
          alert("Mesajınız iletilmiştir.");

          window.location.reload();
        }
        if (result["m"] == "se") {
          alert("Sunucu hatası.");
        }
        if (result["m"] == "sce") {
          alert("Sunucu hatası.");
        }
        if (result["m"] == "Too many requests!") {
          alert("Çok istek atıldı 15 dakika sonra tekrar deneyiniz.");
        }
      })
      .catch((e) => {
        alert("Çok fazla istek atıldı 15 dakika bekleyin.");
      });
  };
  render() {
    return (
      <form
        id="contact-form"
        action=""
        method="post"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-lg-12 mb-4">
            <fieldset>
              <label htmlFor="name" style={{ fontWeight: "600" }}>
                Ad Soyad
              </label>
              <input
                type="text"
                name="name"
                id="name"
                placeholder="Adınız Soyadınız..."
                autoComplete="on"
                required
                className="form-control"
                onChange={(e) => {
                  this.setState({ fullName: e.target.value });
                }}
                style={{
                  padding: "12px",
                  borderRadius: "5px",
                  border: "1px solid #e6e6e6",
                  marginBottom: "0px",
                }}
              />
            </fieldset>
          </div>
          <div className="col-lg-12 mb-4">
            <fieldset>
              <label htmlFor="phone" style={{ fontWeight: "600" }}>
                Telefon Numarası
              </label>
              <div style={{ display: "flex", alignItems: "stretch" }}>
                <span
                  style={{
                    padding: "0 15px",
                    display: "flex",
                    alignItems: "center",
                    background: "#f7f7f7",
                    borderRadius: "5px 0 0 5px",
                    border: "1px solid #e6e6e6",
                    borderRight: "none",
                    height: "46px",
                  }}
                >
                  +90
                </span>
                <input
                  type="tel"
                  name="phone"
                  id="phone"
                  placeholder="5XX XXX XX XX"
                  autoComplete="on"
                  required
                  className="form-control"
                  value={this.state.phone}
                  onChange={this.handlePhoneChange}
                  style={{
                    borderRadius: "0 5px 5px 0",
                    flex: "1",
                    padding: "12px",
                    border: "1px solid #e6e6e6",
                    height: "46px",
                    marginBottom: "0px",
                  }}
                />
              </div>
              <small
                style={{
                  color: "#666",
                  marginTop: "5px",
                  display: "block",
                  fontSize: "0.75rem",
                }}
              >
                Örnek: 5XX XXX XX XX
              </small>
            </fieldset>
          </div>
          <div className="col-lg-12 mb-4">
            <fieldset>
              <label htmlFor="subject" style={{ fontWeight: "600" }}>
                İletişim Nedeni
              </label>
              <select
                name="subject"
                id="subject"
                required
                className="form-control"
                onChange={(e) => {
                  this.setState({ iletisimNedeni: e.target.value });
                }}
                style={{
                  padding: "12px",
                  borderRadius: "5px",
                  border: "1px solid #e6e6e6",
                  backgroundColor: "#f6f6f6",
                }}
              >
                <option value="" disabled selected>
                  Seçiniz...
                </option>
                <option value="satin-alma">Satın alma</option>
                <option value="kiralama">Kiralama</option>
                <option value="satis">Satış</option>
                <option value="kiraya-verme">Kiraya verme</option>
              </select>
            </fieldset>
          </div>
          <div className="col-lg-12 mb-4">
            <fieldset>
              <label htmlFor="message" style={{ fontWeight: "600" }}>
                Açıklama
              </label>
              <textarea
                name="message"
                id="message"
                placeholder="Mesajınız..."
                className="form-control"
                onChange={(e) => {
                  this.setState({ aciklama: e.target.value });
                }}
                rows="5"
                style={{
                  padding: "12px",
                  borderRadius: "5px",
                  border: "1px solid #e6e6e6",
                  resize: "vertical",
                }}
              ></textarea>
            </fieldset>
          </div>
          <div className="col-lg-12 mt-4">
            <fieldset>
              <button
                type="submit"
                id="form-submit"
                className="orange-button"
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "600",
                  background: "#00519A",
                  color: "White",
                }}
              >
                Gönder
              </button>
            </fieldset>
          </div>
        </div>
      </form>
    );
  }
}
